import type { QuestionTypeV1 } from 'enum/question-type'
import api from '../..'

export interface IAnswerOpenEndedAttributes {
  content: string
  answer_attributes: { block_instance_id: number; question_id: number }
}

export interface IAnswerOpenEnded {
  id: number
  answer: Answer
  content: string
  createdAt: string
  updatedAt: string
}

export interface Answer {
  id: number
  answerableType: QuestionTypeV1.openEnded
  answerableId: number
  blockInstanceId: number
  questionId: number
  enrolId: number
  createdAt: Date
  updatedAt: Date
}

const answerOpenEndedCreate = (answerOpenEnded: IAnswerOpenEndedAttributes) => {
  return api
    .post<{ data: { attributes: IAnswerOpenEnded } }>(
      'answers/open_endeds',
      answerOpenEnded
    )
    .then((response) => response.data.data.attributes)
}

export default answerOpenEndedCreate
